







import { Component, Vue } from 'vue-property-decorator';
import GlobalHeader from "@/components/GlobalHeader.vue";
import ClosuresBody from "@/components/ClosuresBody.vue";

@Component({
    components: { GlobalHeader, ClosuresBody }
})
export default class Closures extends Vue {}

